require('./scss/listing-header.scss');

import moment from 'moment';
import QuoteHeader from '../../lang/QuoteHeader';
import branding from '../../mixins/branding';

export default {
    name: "ListingHeader",
    mixins: [branding],
    props:['toggleFilterOptionsVisible', 'toggleTermsConditionsVisible','toggleEditSearchVisible'],
    template: `
<div class="listing-header-wrapper">
<div class="listing-header">
        <div class="location" v-if="quote">
            <div class="pickup">
                <span class="location-name">{{quote.pickup_location.data.name}}</span>
                <time>{{pickUpDateTime.locale(locale).format('ddd MMM DD YYYY')}}</time> at
                <time>{{pickUpDateTime.format('HH:mm')}}</time>
            </div>
            <div class="separator">&rarr;</div>
            <div class="dropoff">
                <span class="location-name">{{quote.dropoff_location.data.name}}</span>
                <time>{{dropOffDateTime.locale(locale).format('ddd MMM DD YYYY')}}</time> at
                <time>{{dropOffDateTime.format('HH:mm')}}</time>
            </div>
        </div>
        <div class="buttons">
            <button class="btn btn-default"
                    aria-expanded="false"
            @click="toggleEditSearchVisible"><img :src="brandingImagesPath('/images/vehicle-listing/edit-search.svg')" alt="">{{$t('QuoteHeader.edit')}}</button>
            <button class="btn btn-default" @click="toggleTermsConditionsVisible"><img :src="brandingImagesPath('/images/vehicle-listing/location-tc.svg')" alt="">{{$t('QuoteHeader.location')}}</button>
            <button class="btn btn-default" @click="toggleFilterOptionsVisible"><img :src="brandingImagesPath('/images/vehicle-listing/sort.svg')" alt="">{{$t('QuoteHeader.filter')}}</button>
        </div>
    </div></div>`,
    i18n: QuoteHeader,
    computed: {
        pickUpDateTime() {
            if (!this.quote.start_date || !this.quote.start_time) {
                return moment();
            }

            return moment(`${this.quote.start_date} ${this.quote.start_time}`);
        },
        dropOffDateTime() {
            if (!this.quote.end_date || !this.quote.end_time) {
                return moment();
            }

            return moment(`${this.quote.end_date} ${this.quote.end_time}`);
        },
        quote() {
            return this.$store.state.quotes.quote;
        },
        locale() {
            var dateLocale = window.greenmotion.locale || 'en';

            switch(dateLocale) {
                case 'me':
                    dateLocale = 'hr';
                    break;
                case 'mx':
                    dateLocale = 'es';
                    break;
            }
            return dateLocale;
        }
    }
};

